export default {
  setReportTokenState(state, token) {
    state.token = token;
  },
  setReportDataState(state, data) {
    state.data = data;
  },
  setReportLoadingState(state, loading) {
    state.loading = loading;
  },
};
